module.exports = __webpack_public_path__ + "static/media/11.7e9a0a35.png";